// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3WwGm","wrapper-form":"wrapper-form__2hoWf","form-wrapper":"form-wrapper__32cCc","errortips-wrapper":"errortips-wrapper__37Od1","errortips":"errortips__35ITP","submit":"submit__N3_Hi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/User/ResetPassword/styles/main.scss
// module id = 2322
// module chunks = 1